import { Component } from '@angular/core';

@Component({
    selector: 'app-pricing-table-mobile',
    templateUrl: './pricing-table-mobile.component.html',
    styleUrls: ['./pricing-table-mobile.component.scss'],
    standalone: false
})
export class PricingTableMobileComponent {
  constructor() {}
}
